import { useMemo as t } from "react";
import "@chakra-ui/system";
import { tokenTransform as e } from "../../utils/tokenTransformWithBaseFont.js";
const f = (o, r) => t(() => e(o, r), [r]);
export {
  f as useTransformTokens
};
